"use client";
import { Page } from "components/layout/Layout";
import "@/styles/critical/_section-promo.scss";
import { SectionPromo } from "@/components/shared/sections/SectionPromo";
import { useErrorPage } from "@/helpers/useErrorPage";

export default function Custom404() {
  useErrorPage("404 | StudyCrumb");

  return (
    <Page>
      <SectionPromo
        heading="404"
        subheading="Looks like it's the wrong address, or the page has been moved."
        button={{
          text: "Go home",
          props: {
            href: "/",
          },
        }}
        height="stretch"
      />
    </Page>
  );
}
